import { ReviewsPlain } from './reviews_plain.js';
import { LocationBaseMixin } from './location_base_mixin.js';

class LocationPlain extends LocationBaseMixin(Object) {
  constructor(
    loc = {},
    getLocationFrom = locData => new LocationPlain(locData)
  ) {
    super(loc, getLocationFrom);
  }
  static Reviews = ReviewsPlain;
}

export { LocationPlain };
